import { useEffect, useState } from "react";

/**
 * Tracks filter submit/loading state. Dropdowns stay disabled while busy;
 * the Filter button stays enabled and only shows a loading label.
 */
export const useCptFilterLoading = (loading = false) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!loading) {
      setIsSubmitting(false);
    }
  }, [loading]);

  const beginSubmit = () => setIsSubmitting(true);
  const isFilterBusy = Boolean(loading) || isSubmitting;

  return { isFilterBusy, beginSubmit };
};
